export const parallelAgentsGuide = {
  "title": "Browser checks with parallel AI agents",
  "seoTitle": "Browser checks with parallel AI agents | Rill",
  "slug": "parallel-ai-agents-browser-testing",
  "date": "2026-10-30",
  "description": "Give each coding agent its own recorded browser with Rill. Label feature previews, capture checkout and onboarding checks, and review what happened."
} as const;
